/* eslint-disable */
import _ from 'underscore';
import backbone from 'backbone';
import ko from 'knockout';
import $ from 'jquery';
import ViewModel from '@bingads-webui-component-legacy/url-input/viewmodel/url-input';
import tmpl from '@bingads-webui-component-legacy/url-input/template/url-input.pug';
var UrlEditorView = backbone.View.extend({
  events: {},
  initialize: function (options) {
    this.options = options || ({});
    _.defaults(this.options, {
      template: tmpl,
      urlPlaceholder: '',
      errorContainer: '',
      ariaId: '',
      required: false,
      view: this
    });
    this.ko_model = new ViewModel(this.options);
    this.ko_model.fullUrl.subscribe(function (value) {
      this.trigger('urlChanged', value);
    }, this);
    this.ko_model.onBlur = (function () {
      this.trigger('urlFocusout', this.ko_model.fullUrl());
    }).bind(this);
  },
  render: function () {
    this.$el.html(this.options.template({
      inputProtocol: this.options.inputProtocol,
      urlPlaceholder: this.options.urlPlaceholder,
      ariaLabelledby: this.options.ariaLabelledby,
      ariaId: this.options.ariaId + 'protocolOptions',
      required: this.options.required
    }));
    ko.applyBindings(this.ko_model, this.el);
    return this;
  },
  hasErrors: function (value) {
    this.ko_model.hasErrors(value);
  },
  remove: function () {
    ko.cleanNode(this.el);
    return this;
  },
  getFullUrl: function () {
    return this.ko_model.fullUrl();
  },
  setDisabled: function (value) {
    this.ko_model.isDisabled(!!value);
  },
  setError: function (errorMessage) {
    this.ko_model.errorMessage(errorMessage);
  }
});
export default UrlEditorView;

